

// update price on subscription selector change
const subscriptionSelectors = document.querySelectorAll('.subscription-selector input');

subscriptionSelectors.forEach(subscriptionSelector => {
    subscriptionSelector.addEventListener('change', function() {

        const parentForm = this.closest('form');

        // update price in ATC button
        const atcButton = parentForm.querySelector('.button[type="submit"] .atc-price');
        const quantity = parentForm.querySelector('input[name="quantity"]:checked')?.value || 1;
        const price = this.dataset.price;

        if (atcButton && quantity && price) {
            const finalPrice = theme.Currency.formatMoney(price * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
            atcButton.innerHTML = finalPrice;
        }

        // update per drink price
        const perDrinkEl = parentForm.querySelector('.per-drink');
        const servingsPerPack = perDrinkEl?.dataset.drinksPerPack;

        if (perDrinkEl && servingsPerPack) {
            const costPerDrink = theme.Currency.formatMoney(price / Number(servingsPerPack), theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
            perDrinkEl.querySelector('span').innerHTML = costPerDrink;
        }

        // change 'best value' to 'x% off' metafield text
        const isOtp = parentForm.querySelector('input[name="selling_plan"]:checked').value == "";
        const popularTextEls = parentForm.querySelectorAll('.popular-text');
        const discountTextEls = parentForm.querySelectorAll('.discount-text');

        if (isOtp) {
            popularTextEls.forEach(el => el.classList.add('hidden'));
            discountTextEls.forEach(el => el.classList.remove('hidden'))
        } else {
            popularTextEls.forEach(el => el.classList.remove('hidden'));
            discountTextEls.forEach(el => el.classList.add('hidden'));
        }

    });
});


// update price on quantity selector change
const quantitySelectors = document.querySelectorAll('input[name="quantity"]');

quantitySelectors.forEach(input => {
    input.addEventListener('change', function() {
        const parentForm = this.closest('form');

        // update price in ATC button
        const atcButton = parentForm.querySelector('.button[type="submit"] .atc-price');
        const quantity = parentForm.querySelector('input[name="quantity"]:checked')?.value || 1;
        const price = parentForm.querySelector('input[name="selling_plan"]:checked').dataset.price;

        if (atcButton && quantity && price) {
            const finalPrice = theme.Currency.formatMoney(price * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
            atcButton.innerHTML = finalPrice;
        }

        // update per drink price
        const perDrinkEl = parentForm.querySelector('.per-drink');
        const servingsPerPack = perDrinkEl?.dataset.drinksPerPack;

        if (perDrinkEl && servingsPerPack) {
            const costPerDrink = theme.Currency.formatMoney(price / Number(servingsPerPack), theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);
            perDrinkEl.querySelector('span').innerHTML = costPerDrink;
        }

        // update price inside subscription selector
        const subPrice = parentForm.querySelector('input[name="selling_plan"][id*="subscribe"]').dataset.price;
        const otpPrice = parentForm.querySelector('input[name="selling_plan"][id*="otp"]').dataset.price;

        const subPriceEls = parentForm.querySelectorAll('.subscription-price');
        const otpPriceEls = parentForm.querySelectorAll('.otp-price');

        subPriceEls.forEach(el => el.innerHTML = theme.Currency.formatMoney(subPrice * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat))
        otpPriceEls.forEach(el => el.innerHTML = theme.Currency.formatMoney(otpPrice * quantity, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat))

    })
})
